export const storage = {
    data: () => ({
        storeFields: [],
        storePrefix : ''
    }),
    methods: {
        saveToLocalStorage() {
            for (let i = 0; i < this.storeFields.length; i++) {
                localStorage.setItem(`${this.storePrefix}-${this.storeFields[i]}`, this.form[this.storeFields[i]]);
            }
        },
        getFromLocalStorage() {
            for (let i = 0; i < this.storeFields.length; i++) {
                let value = localStorage.getItem(`${this.storePrefix}-${this.storeFields[i]}`);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.storeFields[i]] = value;
                }
            }
        },
        /**
         * Initialize the storage mixin
         * @param {Array<string>} fields
         * @param {?string} prefix
         */
        initStorage(fields, prefix = null){
            this.storeFields = fields
            this.storePrefix = prefix || this.$route.name || this.$route.path

            this.getFromLocalStorage()
        }
    }
}
